'use strict';

const Reflux = require('@muzzylane/reflux');
const Promise = require('bluebird');
const _ = {
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
};

const AnalyticsActions = require('../actions/AnalyticsActions');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');

// author channel/project/act analytics
let overviewAnalytics = {};
let overviewAnalyticsRange = {};
let overviewAnalyticsRangeDates = {};
let projectOverviewAnalytics = {};
let projectOverviewAnalyticsRange = {};
let channelProjectOverview = {};
let channelActivityOverview = {};
let channelActivityCustomAnalyticsCSV = [];
let projectActivityOverview = {};
let projectShortCourseOverview = {};
let channelActivityOverviewRange = {};
let channelActivityShareRange = {};
let projectShareRange = {};
let channelShareRange = {};
let channelShortCourseOverviewRange = {};
let publishedActChannelCounts = {};
let publishedActProjectCounts = {};
let projectActivitiesRangeTotals = {};
let projectActivitiesRangeTotalsDates = {};
let projectActivitiesRangeTotalsPending = null;
let activityCompletionStats = {};
let activityCompletionStatsDates = {};
let activityCompletionStatsPending = null;
// author-facing assn analytics
let activityStats = {};
let shortCourseStats = {};
let activityAssignments = {};
let shortCourseInstances = {};
let newStudentStats = {};
let newStudentStatsDates = {};
// author course (3p) stats
let channelCourseStats = {};
let channelCourseNewStudentRange = {};
let channelCourseNewStudentRangeCSV = {};
// share stats for channel
let channelShareMonthStats = {};
let channelActivityShareMonthStats = {};
let channelProjectShareMonthStats = {};
// in-assignment instructor/student analytics
let assignmentStats = {};
let assignmentRangeStats = {};
// instructor/author-facing qla analytics
let activityQlaVersions = {};
let activityQlaUsage = {};
let activityQlaLoUsage = {};
let activityQlaQuestionSummary = {};
let activityQlaQuestionDetails = {};
let activityWeights = {};
let assnActQlaUsage = {};
let assnActQlaLoUsage = {};
let assnActQlaQuestionSummary = {};
let assnActQlaQuestionDetails = {};

let assnQlaUsage = {};
let assnQlaLoUsage = {};
let assnQlaQuestionSummary = {};
let assnQlaQuestionDetails = {};

// short course instance in-assignment instructor/student analytics
let shortCourseInstanceStats = {};
//let shortCourseInstanceRangeStats = {};

let action = {};
let error = null;

const AnalyticsStore = Reflux.createStore({
    listenables: [AnalyticsActions, SignInActions],
    init: function() {},

    resetState: function() {
        overviewAnalytics = {};
        overviewAnalyticsRange = {};
        projectOverviewAnalytics = {};
        projectOverviewAnalyticsRange = {};
        channelProjectOverview = {};
        channelActivityOverview = {};
        channelCourseStats = {};
        channelCourseNewStudentRange = {};
        channelShareMonthStats = {};
        channelActivityShareMonthStats = {};
        channelProjectShareMonthStats = {};
        projectActivityOverview = {};
        projectShortCourseOverview = {};
        activityStats = {};
        shortCourseStats = {};
        channelActivityOverviewRange = {};
        channelActivityShareRange = {};
        projectShareRange = {};
        channelShareRange = {};
        channelShortCourseOverviewRange = {};
        activityAssignments = {};
        shortCourseInstances = {};
        assignmentStats = {};
        assignmentRangeStats = {};
        newStudentStats = {};
        publishedActChannelCounts = {};
        publishedActProjectCounts = {};
        overviewAnalyticsRangeDates = {};
        newStudentStatsDates = {};
        activityQlaVersions = {};
        activityQlaUsage = {};
        activityQlaLoUsage = {};
        activityQlaQuestionSummary = {};
        activityQlaQuestionDetails = {};
        activityWeights = {};
        assnActQlaUsage = {};
        assnActQlaLoUsage = {};
        assnActQlaQuestionSummary = {};
        assnActQlaQuestionDetails = {};
        assnQlaUsage = {};
        assnQlaLoUsage = {};
        assnQlaQuestionSummary = {};
        assnQlaQuestionDetails = {};
        channelActivityCustomAnalyticsCSV = [];
        projectActivitiesRangeTotals = {};
        projectActivitiesRangeTotalsDates = {};
        activityCompletionStats = {};
        activityCompletionStatsDates = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            // initialized: initialized, //not applicable
            overviewAnalytics: overviewAnalytics,
            overviewAnalyticsRange: overviewAnalyticsRange,
            projectOverviewAnalytics: projectOverviewAnalytics,
            projectOverviewAnalyticsRange: projectOverviewAnalyticsRange,
            channelProjectOverview: channelProjectOverview,
            channelActivityOverview: channelActivityOverview,
            channelCourseStats: channelCourseStats,
            channelCourseNewStudentRange: channelCourseNewStudentRange,
			channelCourseNewStudentRangeCSV: channelCourseNewStudentRangeCSV,
            channelShareMonthStats: channelShareMonthStats,
            channelActivityShareMonthStats: channelActivityShareMonthStats,
            channelProjectShareMonthStats: channelProjectShareMonthStats,
            projectActivityOverview: projectActivityOverview,
            projectShortCourseOverview: projectShortCourseOverview,
            activityStats: activityStats,
            shortCourseStats: shortCourseStats,
            channelActivityOverviewRange: channelActivityOverviewRange,
            channelActivityShareRange: channelActivityShareRange,
            projectShareRange: projectShareRange,
            channelShareRange: channelShareRange,
            channelShortCourseOverviewRange: channelShortCourseOverviewRange,
            activityAssignments: activityAssignments,
            shortCourseInstances: shortCourseInstances,
            assignmentStats: assignmentStats,
            assignmentRangeStats: assignmentRangeStats,
            newStudentStats: newStudentStats,
            shortCourseInstanceStats: shortCourseInstanceStats,
            publishedActChannelCounts: publishedActChannelCounts,
            publishedActProjectCounts: publishedActProjectCounts,
            overviewAnalyticsRangeDates: overviewAnalyticsRangeDates,
            newStudentStatsDates: newStudentStatsDates,
            activityQlaVersions: activityQlaVersions,
            activityQlaUsage: activityQlaUsage,
            activityQlaLoUsage: activityQlaLoUsage,
            activityQlaQuestionSummary: activityQlaQuestionSummary,
            activityQlaQuestionDetails: activityQlaQuestionDetails,
            activityWeights: activityWeights,
            assnActQlaUsage: assnActQlaUsage,
            assnActQlaLoUsage: assnActQlaLoUsage,
            assnActQlaQuestionSummary: assnActQlaQuestionSummary,
            assnActQlaQuestionDetails: assnActQlaQuestionDetails,
            assnQlaUsage: assnQlaUsage,
            assnQlaLoUsage: assnQlaLoUsage,
            assnQlaQuestionSummary: assnQlaQuestionSummary,
            assnQlaQuestionDetails: assnQlaQuestionDetails,
            // channelActivityCustomAnalyticsCSV: channelActivityCustomAnalyticsCSV,
            projectActivitiesRangeTotals: projectActivitiesRangeTotals,
            projectActivitiesRangeTotalsDates: projectActivitiesRangeTotalsDates,
            projectActivitiesRangeTotalsPending: projectActivitiesRangeTotalsPending,
            activityCompletionStats: activityCompletionStats,
            activityCompletionStatsDates: activityCompletionStatsDates,
            activityCompletionStatsPending: activityCompletionStatsPending,
            action: action,
            error: error
        }
    },

    getCustomAnalyticsState: function(channelId,activityId,version) {
        return _.find(channelActivityCustomAnalyticsCSV,{channelId,activityId,version});
    },

    emitStatus: function() {
        //console.log("activity store: EMIT");
        this.trigger(this.getState());
        action = {};
        error = null;
    },

    onError: function(actionID, err) {
        action.id = actionID;
        if(err.status){
            switch(err.status){
                case 422:
                    action.error = new ForgeError({message: err.responseText});
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
                    break;
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onGetChannelOverviewCompleted: function(actionID, channelId, res) {
        // console.log("onGetChannelOverviewCompleted: ", actionID, channelId, res);
        action = {id: actionID};

        if(overviewAnalytics[channelId]) {
            delete overviewAnalytics[channelId];
        }

        overviewAnalytics[channelId] = {}
        overviewAnalytics[channelId].initialized = true;
        overviewAnalytics[channelId].analytics = res;

        this.emitStatus();
    },

    onGetChannelOverviewFailed: function(actionID, channelId, err) {
        console.warn("onGetChannelOverviewFailed: ", actionID, channelId, err);
        this.onError(actionID, err);
    },

    onGetProjectOverviewCompleted: function(actionId, projectId, res) {
        // console.log('onGetProjectOverviewCompleted:', actionId, projectId, res);
        action = { id: actionId };
        if (projectOverviewAnalytics[projectId]) delete projectOverviewAnalytics[projectId];
        projectOverviewAnalytics[projectId] = res;
        this.emitStatus();
    },

    onGetProjectOverviewFailed: function(actionId, projectId, err) {
        console.warn('onGetProjectOverviewFailed:', actionId, projectId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelOverviewRangeCompleted: function(actionID, channelId, res, startDate, endDate) {
        // console.log("onGetChannelOverviewRangeCompleted: ", actionID, channelId, res, startDate, endDate);
        action = {id: actionID};

        if(overviewAnalyticsRange[channelId]) {
            delete overviewAnalyticsRange[channelId];
        }

        overviewAnalyticsRange[channelId] = {}
        overviewAnalyticsRange[channelId].initialized = true;
        overviewAnalyticsRange[channelId].timeseriesCol = res.timeseriesCol;
        overviewAnalyticsRange[channelId].assignmentsCol = res.assignmentsCol;
        overviewAnalyticsRange[channelId].attemptsCol = res.attemptsCol;
        overviewAnalyticsRange[channelId].activeStudentsCol = res.activeStudentsCol;
        overviewAnalyticsRange[channelId].activeStudentsTotal = res.activeStudentsTotal;
        overviewAnalyticsRange[channelId].nonEmptyAssnCount = res.nonEmptyAssnCount;

        overviewAnalyticsRangeDates[channelId] = {};
        overviewAnalyticsRangeDates[channelId].startDate = startDate;
        overviewAnalyticsRangeDates[channelId].endDate = endDate;

        this.emitStatus();
    },

    onGetChannelOverviewRangeFailed: function(actionID, channelId, err) {
        console.warn("onGetChannelOverviewRangeFailed: ", actionID, channelId, err);
        this.onError(actionID, err);
    },

    onGetChannelProjectOverviewCompleted: function(actionID, channelId, res) {
        // console.log("onGetChannelProjectOverviewCompleted: ", actionID, channelId, res);
        action = { id: actionID };

        if (channelProjectOverview[channelId]) {
            delete channelProjectOverview[channelId];
        }

        channelProjectOverview[channelId] = res;
        this.emitStatus();
    },

    onGetChannelProjectyOverviewFailed: function(actionID, channelId, err) {
        console.warn('onGetChannelProjectyOverviewFailed: ', actionID, channelId, err);
        this.onError(actionID, err);
    },

    onGetProjectOverviewRangeCompleted: function(actionId, projectId, res) {
        // console.log("onGetProjectOverviewRangeCompleted: ", actionId, projectId, res);
        action = { id: actionId };
        if (projectOverviewAnalyticsRange[projectId]) delete projectOverviewAnalyticsRange[projectId];
        projectOverviewAnalyticsRange[projectId] = res;
        this.emitStatus();
    },

    onGetProjectOverviewRangeFailed: function(actionId, projectId, err) {
        console.warn("onGetProjectOverviewRangeFailed: ", actionId, projectId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelActivityOverviewCompleted: function(actionID, channelId, res) {
        // console.log("onGetChannelActivityOverviewCompleted: ", actionID, channelId, res);
        action = {id: actionID};

        if(channelActivityOverview[channelId]) {
            delete channelActivityOverview[channelId];
        }

        channelActivityOverview[channelId] = {}
        channelActivityOverview[channelId].initialized = true;
        channelActivityOverview[channelId].analytics = res;

        this.emitStatus();
    },

    onGetChannelActivityOverviewFailed: function(actionID, channelId, err) {
        console.warn("onGetChannelActivityOverviewFailed: ", actionID, channelId, err);
        this.onError(actionID, err);
    },

    onGetChannelCourseStatsCompleted: function(actionID, channelId, res) {
        action = {id: actionID};

        if(channelCourseStats[channelId]) {
            delete channelCourseStats[channelId];
        }

        channelCourseStats[channelId] = {}
        channelCourseStats[channelId].initialized = true;
        channelCourseStats[channelId].courseStats = res.courseStats;

        this.emitStatus();
    },

    onGetChannelCourseStatsFailed: function(actionID, channelId, err) {
        console.warn("onGetChannelCourseStatsFailed: ", actionID, channelId, err);
        this.onError(actionID, err);
    },
    
    onGetChannelCourseNewStudentRangeCompleted: function(actionID, channelId, res) {
        action = {id: actionID};

        if(channelCourseNewStudentRange[channelId]) {
            delete channelCourseNewStudentRange[channelId];
        }

        channelCourseNewStudentRange[channelId] = {}
        channelCourseNewStudentRange[channelId].initialized = true;
        channelCourseNewStudentRange[channelId].error = null;
        channelCourseNewStudentRange[channelId].courseStats = res.courseStats;

        this.emitStatus();
    },

    onGetChannelCourseNewStudentRangeFailed: function(actionID, channelId, err) {
        console.warn("onGetChannelCourseNewStudentRangeFailed: ", actionID, channelId, err);
        channelCourseNewStudentRange[channelId] = {}
        channelCourseNewStudentRange[channelId].initialized = true;
        channelCourseNewStudentRange[channelId].error = err;
        channelCourseNewStudentRange[channelId].courseStats = [];
        this.onError(actionID, err);
    },

    onGetChannelShareMonthOverviewCompleted: function(actionId, channelId, date, res) {
        action = { id: actionId };
        if (!channelShareMonthStats[channelId]) {
            channelShareMonthStats[channelId] = {};
        }
        
        channelShareMonthStats[channelId][date] = res;
        this.emitStatus();
    },

    onGetChannelShareMonthOverviewFailed: function(actionId, channelId, date, err) {
        console.warn("onGetChannelShareMonthOverviewFailed: ", actionId, channelId, date, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelActivityShareMonthOverviewCompleted: function(actionId, channelId, activityId, date, res) {
        action = { id: actionId };
        if (!channelActivityShareMonthStats[channelId]) {
            channelActivityShareMonthStats[channelId] = {};
        }

        if (!channelActivityShareMonthStats[channelId][activityId]) {
            channelActivityShareMonthStats[channelId][activityId] = {};
        }

        channelActivityShareMonthStats[channelId][activityId][date] = res;
        this.emitStatus();
    },

    onGetChannelActivityShareMonthOverviewFailed: function(actionId, channelId, activityId, date, err) {
        console.warn("onGetChannelActivityShareMonthOverviewFailed: ", actionId, channelId, activityId, date, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelProjectShareMonthOverviewCompleted: function(actionId, channelId, projectId, date, res) {
        action = { id: actionId };
        if (!channelProjectShareMonthStats[channelId]) {
            channelProjectShareMonthStats[channelId] = {};
        }

        if (!channelProjectShareMonthStats[channelId][projectId]) {
            channelProjectShareMonthStats[channelId][projectId] = {};
        }

        channelProjectShareMonthStats[channelId][projectId][date] = res;
        this.emitStatus();
    },

    onGetChannelProjectShareMonthOverviewFailed: function(actionId, channelId, projectId, date, err) {
        console.warn("onGetChannelProjectShareMonthOverviewFailed: ", actionId, channelId, projectId, date, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelPublishedActCountsCompleted: function(actionId, channelId, res) {
        //console.log("onGetChannelPublishedActCountsCompleted", actionId, channelId, res);
        action = { id: actionId };
        publishedActChannelCounts[channelId] = res;
        this.emitStatus();
    },

    onGetChannelPublishedActCountsFailed: function(actionId, channelId, err) {
        console.warn("onGetChannelPublishedActCountsFailed: ", actionId, channelId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetProjectPublishedActCountsCompleted: function(actionId, projectId, res) {
        console.log("onGetProjectPublishedActCountsCompleted", actionId, projectId, res);
        action = { id: actionId };
        publishedActProjectCounts[projectId] = res;
        this.emitStatus();
    },

    onGetProjectPublishedActCountsFailed: function(actionId, projectId, err) {
        console.warn("onGetProjectPublishedActCountsFailed: ", actionId, projectId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelCourseNewStudentRangePageCompleted: function(actionID, channelId, course_db_id, assignment_db_id, res) {
        action = {id: actionID};


        let courseStats = channelCourseNewStudentRange[channelId].courseStats;
        let course = courseStats && _.find(courseStats, { id: course_db_id });
        let assignment = course && _.find(course.assignments, { id: assignment_db_id });
        if (!assignment) {
            console.warn("onGetChannelCourseNewStudentRangePageCompleted but channelCourseNewStudentRange is not available");
            this.emitStatus();
            return;
        }
        assignment.students = res.students;
        assignment.students_offset = res.offset;
        // also available: res.startDate, res.endDate, res.limit
        this.emitStatus();
    },

    onGetChannelCourseNewStudentRangePageFailed: function(actionID, channelId, course_db_id, assignment_db_id, err) {
        console.warn("onGetChannelCourseNewStudentRangePageFailed: ", actionID, channelId, course_db_id, assignment_db_id, err);
        this.onError(actionID, err);
    },

	onGetChannelCourseNewStudentRangeAllPagesCSVCompleted: function(actionID, channelId, res) {
        action = {id: actionID};

        if(channelCourseNewStudentRangeCSV[channelId]) {
            delete channelCourseNewStudentRangeCSV[channelId];
        }

		let csvData = { ...res, 
			csv_url: `/authoring/analytics/channel/${channelId}/csv/${res.csv_filename}`
		};

        channelCourseNewStudentRangeCSV[channelId] = {
			initialized: true,
			error: null,
			csvData: csvData 
		}

        this.emitStatus();

	},

	onGetChannelCourseNewStudentRangeAllPagesCSVFailed: function(actionID, channelId, err) {
        console.warn("onGetChannelCourseNewStudentRangeAllPagesCSVFailed: ", actionID, channelId, err);
        channelCourseNewStudentRangeCSV[channelId] = {
			initialized: true,
			error: err,
			csvData: {}
		}
        this.onError(actionID, err);
	},

    onGetChannelActivityCustomAnalyticsCompleted: function(actionID, params, res) {
        action = {id: actionID};
        let channelId = params.channelId;
        let activityId = params.activityId;
        let version = params.version;
		let csvData = { ...res, 
			csv_url: `/authoring/analytics/channel/${channelId}/csv/${res.csv_filename}`
		};
        let query = { channelId, activityId, version };
        let xi = _.findIndex(channelActivityCustomAnalyticsCSV,query);
        let result = {
            ...query, 
            initialized: true,
            error: null,
            csvData: csvData 
        }
        if (xi >= 0) {
            channelActivityCustomAnalyticsCSV[xi] = result;
        }
        else {
            channelActivityCustomAnalyticsCSV.push(result);
        }
        this.emitStatus();
    },
    
    onGetChannelActivityCustomAnalyticsFailed: function(actionID, params, err) {
        console.warn("onGetChannelActivityCustomAnalyticsFailed: ", actionID, params, err);
        action = {id: actionID};
        this.onError(actionID, err);
    },
    
	onClearChannelCSVCompleted: function(actionID, channelId, csv_filename, res) {
        action = {id: actionID};
		let csvData = channelCourseNewStudentRangeCSV[channelId] && channelCourseNewStudentRangeCSV[channelId].csvData;
		if (csvData && csvData.csv_filename === csv_filename) {
			delete channelCourseNewStudentRangeCSV[channelId];
		}
		else {
			console.warn("onClearChannelCompleted but no client data was present", actionID, channelId, csv_filename, res);
		}
        this.emitStatus();
	},

	onClearChannelCSVFailed: function(actionID, channelId, err) {
        console.warn("onClearChannelCSVFailed: ", actionID, channelId, err);
        this.onError(actionID, err);
	},
	
    onGetProjectActivityOverviewCompleted: function(actionID, projectId, res) {
        // console.log("onGetProjectActivityOverviewCompleted: ", actionID, projectId, res);
        action = {id: actionID};

        if (projectActivityOverview[projectId]) {
            delete projectActivityOverview[projectId];
        }

        projectActivityOverview[projectId] = res.overview;
        this.emitStatus();
    },

    onGetProjectActivityOverviewFailed: function(actionID, projectId, err) {
        console.warn("onGetProjectActivityOverviewFailed: ", actionID, projectId, err);
        this.onError(actionID, err);
    },

    onGetProjectShortCourseOverviewCompleted: function(actionId, projectId, res) {
        // console.log("onGetProjectShortCourseOverviewCompleted: ", actionId, projectId, res);
        action = { id: actionId };

        if (projectShortCourseOverview[projectId]) {
            delete projectShortCourseOverview[projectId];
        }

        projectShortCourseOverview[projectId] = res.overview;
        this.emitStatus();
    },

    onGetProjectShortCourseOverviewFailed: function(actionId, projectId, err) {
        console.warn("onGetProjectShortCourseOverviewFailed: ", actionId, projectId, err);
        this.onError(actionId, err);
    },

    onGetProjectActivitiesRangeTotalsStarted: function(actionId, projectId, startDate, endDate) {
        projectActivitiesRangeTotalsPending = {
            actionId: actionId,
            projectId: projectId,
            startDate: startDate,
            endDate: endDate,
        };
        this.emitStatus();
    },

    onGetProjectActivitiesRangeTotalsCompleted: function(actionId, projectId, startDate, endDate, res) {
        console.log('onGetProjectActivitiesRangeTotalsCompleted', actionId, projectId, startDate, endDate, res);
        action = { id: actionId };
        projectActivitiesRangeTotals[projectId] = res;
        projectActivitiesRangeTotalsDates[projectId] = { startDate: startDate, endDate: endDate };
        projectActivitiesRangeTotalsPending = null;
        this.emitStatus();
    },

    onGetProjectActivitiesRangeTotalsFailed: function(actionId, projectId, startDate, endDate, err) {
        console.warn('onGetProjectActivitiesRangeTotalsFailed', actionId, projectId, startDate, endDate, err);
        action = { id: actionId, error: err };
        projectActivitiesRangeTotalsPending = null;
        this.emitStatus();
    },

    onGetActivityCompletionStatsStarted: function(actionId, activityId, startDate, endDate) {
        activityCompletionStatsPending = {
            actionId: actionId,
            activityId: activityId,
            startDate: startDate,
            endDate: endDate,
        };
        this.emitStatus();
    },

    onGetActivityCompletionStatsCompleted: function(actionId, activityId, startDate, endDate, res) {
        // console.log('onGetActivityCompletionStatsCompleted', actionId, activityId, startDate, endDate, res);
        action = { id: actionId };
        activityCompletionStats[activityId] = res;
        activityCompletionStatsDates[activityId] = { startDate: startDate, endDate: endDate };
        activityCompletionStatsPending = null;
        this.emitStatus();
    },

    onGetActivityCompletionStatsFailed: function(actionId, activityId, startDate, endDate, err) {
        console.warn('onGetActivityCompletionStatsFailed', actionId, activityId, startDate, endDate, err);
        action = { id: actionId, error: err };
        activityCompletionStatsPending = null;
        this.emitStatus();
    },

    onCancelActivityCompletionStatsCompleted: function(actionId) {
        if (!!activityCompletionStatsPending && activityCompletionStatsPending.actionId === actionId) {
            // console.log('onCancelActivityCompletionStatsCompleted', actionId, activityCompletionStatsPending);
            activityCompletionStatsPending = null;
            this.emitStatus();
        }
    },
    
    onGetActivityStatsChannelCompleted: function(actionID, activityId, res) {
        // console.log("onGetActivityStatsChannelCompleted: ", actionID, activityId, res);
        action = {id: actionID};

        if(activityStats[activityId]) {
            delete activityStats[activityId];
        }

        activityStats[activityId] = {...res};

        this.emitStatus();
    },

    onGetActivityStatsChannelFailed: function(actionID, activityId, err) {
        console.warn("onGetActivityStatsChannelFailed: ", actionID, activityId, err);
        this.onError(actionID, err);
    },

    onGetShortCourseStatsChannelCompleted: function(actionId, shortCourseId, res) {
        // console.log("onGetShortCourseStatsChannelCompleted: ", actionId, shortCourseId, res);
        action = { id: actionId };

        if (shortCourseStats[shortCourseId]) {
            delete shortCourseStats[shortCourseId];
        }

        shortCourseStats[shortCourseId] = res;

        this.emitStatus();
    },

    onGetShortCourseStatsChannelFailed: function(actionId, shortCourseId, err) {
        console.warn("onGetShortCourseStatsChannelFailed: ", actionId, shortCourseId, err);
        this.onError(actionId, err);
    },

    onGetChannelActivityOverviewRangeCompleted: function(actionID, activityId, res) {
        // console.log("onGetChannelActivityOverviewRangeCompleted: ", actionID, activityId, res);
        action = {id: actionID};

        if(channelActivityOverviewRange[activityId]) {
            delete channelActivityOverviewRange[activityId];
        }

        channelActivityOverviewRange[activityId] = {}
        channelActivityOverviewRange[activityId].initialized = true;
        channelActivityOverviewRange[activityId].timeseriesCol = res.timeseriesCol;
        channelActivityOverviewRange[activityId].assignmentsCol = res.assignmentsCol;
        channelActivityOverviewRange[activityId].attemptsCol = res.attemptsCol;
        channelActivityOverviewRange[activityId].activeStudentsCol = res.activeStudentsCol;
        channelActivityOverviewRange[activityId].activeStudentsTotal = res.activeStudentsTotal;
        channelActivityOverviewRange[activityId].nonEmptyAssnCount = res.nonEmptyAssnCount;

        this.emitStatus();
    },

    onGetChannelActivityOverviewRangeFailed: function(actionID, activityId, err) {
        console.warn("onGetChannelActivityOverviewRangeFailed: ", actionID, activityId, err);
        this.onError(actionID, err);
    },

    onGetChannelActivityShareRangeCompleted: function(actionId, activityId, res) {
        // console.log("onGetChannelActivityShareRangeCompleted: ", actionID, activityId, res);
        action = { id: actionId };
        if (channelActivityShareRange[activityId]) {
            delete channelActivityShareRange[activityId];
        }

        channelActivityShareRange[activityId] = { initialized: true, ...res };
        this.emitStatus();
    },

    onGetChannelActivityShareRangeFailed: function(actionId, activityId, err) {
        console.warn("onGetChannelActivityShareRangeFailed: ", actionId, activityId, err);
        this.onError(actionId, err);
    },

    onGetProjectShareRangeCompleted: function(actionId, projectId, res) {
        // console.log("onGetProjectShareRangeCompleted: ", actionID, projectId, res);
        action = { id: actionId };
        if (projectShareRange[projectId]) {
            delete projectShareRange[projectId];
        }

        projectShareRange[projectId] = { initialized: true, ...res };
        this.emitStatus();
    },

    onGetProjectShareRangeFailed: function(actionId, projectId, err) {
        console.warn("onGetProjectShareRangeFailed: ", actionId, projectId, err);
        this.onError(actionId, err);
    },

    onGetChannelShareRangeCompleted: function(actionId, channelId, res) {
        // console.log("onGetChannelShareRangeCompleted: ", actionID, channelId, res);
        action = { id: actionId };
        if (channelShareRange[channelId]) {
            delete channelShareRange[channelId];
        }

        channelShareRange[channelId] = { initialized: true, ...res };
        this.emitStatus();
    },

    onGetChannelShareRangeFailed: function(actionId, channelId, err) {
        console.warn("onGetChannelShareRangeFailed: ", actionId, channelId, err);
        this.onError(actionId, err);
    },

    onGetChannelShortCourseOverviewRangeCompleted: function(actionId, shortCourseId, res) {
        console.log("onGetChannelShortCourseOverviewRangeCompleted: ", actionId, shortCourseId, res);
        action = {id: actionId};

        if(channelShortCourseOverviewRange[shortCourseId]) {
            delete channelShortCourseOverviewRange[shortCourseId];
        }

        channelShortCourseOverviewRange[shortCourseId] = {}
        channelShortCourseOverviewRange[shortCourseId].initialized = true;
        channelShortCourseOverviewRange[shortCourseId].timeseriesCol = res.timeseriesCol;
        channelShortCourseOverviewRange[shortCourseId].instancesCol = res.instancesCol;
        channelShortCourseOverviewRange[shortCourseId].attemptsCol = res.attemptsCol;
        channelShortCourseOverviewRange[shortCourseId].activeStudentsCol = res.activeStudentsCol;
        channelShortCourseOverviewRange[shortCourseId].activeStudentsTotal = res.activeStudentsTotal;

        this.emitStatus();
    },

    onGetChannelShortCourseOverviewRangeFailed: function(actionId, shortCourseId, err) {
        console.warn("onGetChannelShortCourseOverviewRangeFailed: ", actionId, shortCourseId, err);
        this.onError(actionId, err);
    },

    onGetActivityAssignmentStatsChannelCompleted: function(actionID, activityId, res) {
        // console.log("onGetActivityAssignmentStatsChannelCompleted: ", actionID, activityId, res);
        action = {id: actionID};

        if(activityAssignments[activityId]) {
            delete activityAssignments[activityId];
        }

        activityAssignments[activityId] = res;

        this.emitStatus();
    },

    onGetActivityAssignmentStatsChannelFailed: function(actionID, activityId, err) {
        console.warn("onGetActivityAssignmentStatsChannelFailed: ", actionID, activityId, err);
        this.onError(actionID, err);
    },


    onGetShortCourseInstanceStatsChannelCompleted: function(actionId, shortCourseId, res) {
        // console.log("onGetShortCourseInstanceStatsChannelCompleted: ", actionID, shortCourseId, res);
        action = { id: actionId };
        if (shortCourseInstances[shortCourseId]) {
            delete shortCourseInstances[shortCourseId];
        }

        shortCourseInstances[shortCourseId] = res;
        this.emitStatus();
    },

    onGetGetShortCourseInstanceStatsChannelFailed: function(actionId, shortCourseId, err) {
        console.warn("onGetGetShortCourseInstanceStatsChannelFailed: ", actionId, shortCourseId, err);
        this.onError(actionId, err);
    },

    onGetAssignmentStatsCompleted: function(actionID, assignmentHash, res) {
        // console.log("onGetAssignmentStatsCompleted: ", actionID, assignmentHash, res);
        action = {id: actionID};

        if(assignmentStats[assignmentHash]) {
            delete assignmentStats[assignmentHash];
        }

        assignmentStats[assignmentHash] = res;

        this.emitStatus();
    },

    onGetAssignmentStatsFailed: function(actionID, assignmentHash, err) {
        console.warn("onGetAssignmentStatsFailed: ", actionID, assignmentHash, err);
        this.onError(actionID, err);
    },

    onGetAssignmentRangeStatsCompleted: function(actionID, assignmentHash, res) {
        // console.log("onGetAssignmentRangeStatsCompleted: ", actionID, assignmentHash, res);
        action = {id: actionID};

        if(assignmentRangeStats[assignmentHash]) {
            delete assignmentRangeStats[assignmentHash];
        }

        assignmentRangeStats[assignmentHash] = res;

        this.emitStatus();
    },

    onGetAssignmentRangeStatsFailed: function(actionID, assignmentHash, err) {
        console.warn("onGetAssignmentRangeStatsFailed: ", actionID, assignmentHash, err);
        this.onError(actionID, err);
    },

    onGetNewStudentStatsRangeCompleted: function(actionId, channelId, res, startDate, endDate) {
        // console.log("onGetNewStudentStatsRangeCompleted: ", actionId, channelId, res, startDate, endDate);
        action = { id: actionId };
        if (newStudentStats[channelId]) delete newStudentStats[channelId];
        newStudentStats[channelId] = res;
        newStudentStatsDates[channelId] = {};
        newStudentStatsDates[channelId].startDate = startDate;
        newStudentStatsDates[channelId].endDate = endDate;
        this.emitStatus();
    },

    onGetNewStudentStatsRangeFailed: function(actionId, channelId, err) {
        console.warn("onGetNewStudentStatsRangeFailed: ", actionId, channelId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityQlaVersionsCompleted: function(actionId, activityId, res) {
        // console.log("onGetActivityQlaVersionsCompleted: ", actionId, activityId, res);
        action = { id: actionId };
        activityQlaVersions[activityId] = res;
        this.emitStatus();

    },

    onGetActivityQlaVersionsFailed: function(actionId, activityId, err) {
        console.warn("onGetActivityQlaVersionsFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityQlaUsageCompleted: function(actionId, activityId, res) {
        // console.log("onGetActivityQlaVersionsCompleted: ", actionId, activityId, res);
        action = { id: actionId };
        activityQlaUsage[activityId] = res;
        this.emitStatus();
    },

    onGetActivityQlaUsageFailed: function(actionId, activityId, err) {
        console.warn("onGetActivityQlaUsageFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityQlaLoUsageCompleted: function(actionId, activityId, res) {
        // console.log("onGetActivityQlaLoUsageCompleted: ", actionId, activityId, res);
        action = { id: actionId };
        activityQlaLoUsage[activityId] = res;
        this.emitStatus();
    },

    onGetActivityQlaLoUsageFailed: function(actionId, activityId, err) {
        console.warn("onGetActivityQlaLoUsageFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityQlaQuestionSummaryCompleted: function(actionId, activityId, res) {
        // console.log("onGetActivityQuestionSummaryCompleted: ", actionId, activityId, res);
        action = { id: actionId };
        activityQlaQuestionSummary[activityId] = res;
        this.emitStatus();
    },

    onGetActivityQlaQuestionSummaryFailed: function(actionId, activityId, err) {
        console.warn("onGetActivityQuestionSummaryFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActivityQlaQuestionDetailsCompleted: function(actionId, activityId, questionId, res) {
        // console.log("onGetActivityQuestionDetailsCompleted: ", actionId, activityId, res);
        action = { id: actionId };
        if (!activityQlaQuestionDetails[activityId]) {
            activityQlaQuestionDetails[activityId] = {};
        }
        activityQlaQuestionDetails[activityId][questionId]= res;
        this.emitStatus();
    },

    onGetActivityQlaQuestionDetailsFailed: function(actionId, activityId, questionId, err) {
        console.warn("onGetActivityQuestionDetailsFailed: ", actionId, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnActWeightsCompleted: function(actionId, assignmentHash, activityId, activityVersion, res) {
        console.log('onGetAssnActWeightsCompleted:', actionId, assignmentHash, activityId, activityVersion, res);
        action = { id: actionId };
        if (!activityWeights[activityId]) activityWeights[activityId] = {};

        const usedActVersion = activityVersion || 'latest';
        activityWeights[activityId][usedActVersion] = res;
        this.emitStatus();
    },

    onGetAssnActWeightsFailed: function(actionId, assignmentHash, activityId, activityVersion, err) {
        console.warn('onGetAssnActWeightsFailed:', actionId, assignmentHash, activityId, activityVersion, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnActQlaUsageCompleted: function(actionId, assignmentHash, activityId, res) {
        // console.log('onGetAssnActQlaUsageCompleted:', actionId, assignmentHash, activityId, res);
        action = { id: actionId };
        assnActQlaUsage[activityId] = res;
        this.emitStatus();
    },
    onGetAssnActQlaUsageFailed: function(actionId, assignmentHash, activityId, err) {
        console.warn('onGetAssnActQlaUsageFailed:', actionId, assignmentHash, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnActQlaLoUsageCompleted: function(actionId, assignmentHash, activityId, res) {
        // console.log('onGetAssnActQlaLoUsageCompleted:', actionId, assignmentHash, activityId, res);
        action = { id: actionId };
        assnActQlaLoUsage[activityId] = res;
        this.emitStatus();
    },
    onGetAssnActQlaLoUsageFailed: function(actionId, assignmentHash, activityId, err) {
        console.warn('onGetAssnActQlaLoUsageFailed:', actionId, assignmentHash, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnActQlaQuestionSummaryCompleted: function(actionId, assignmentHash, activityId, res) {
        // console.log('onGetAssnActQlaQuestionSummaryCompleted:', actionId, assignmentHash, activityId, res);
        action = { id: actionId };
        assnActQlaQuestionSummary[activityId] = res;
        this.emitStatus();

    },
    onGetAssnActQlaQuestionSummaryFailed: function(actionId, assignmentHash, activityId, err) {
        console.warn('onGetAssnActQlaQuestionSummaryFailed:', actionId, assignmentHash, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnActQlaQuestionDetailsCompleted: function(actionId, assignmentHash, activityId, questionId, res) {
        // console.log('onGetAssnActQlaQuestionDetailsCompleted:', actionId, assignmentHash, activityId, res);
        action = { id: actionId };
        if (!assnActQlaQuestionDetails[activityId]) {
            assnActQlaQuestionDetails[activityId] = {};
        }

        assnActQlaQuestionDetails[activityId][questionId] = res;
        this.emitStatus();
    },
    onGetAssnActQlaQuestionDetailsFailed: function(actionId, assignmentHash, activityId, questionId, err) {
        console.warn('onGetAssnActQlaQuestionDetailsFailed:', actionId, assignmentHash, activityId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },




    onGetAssnQlaUsageCompleted(actionId, assignmentHash, res) {
        // console.log('onGetAssnQlaUsageCompleted:', actionId, assignmentHash, res);
        action = { id: actionId };
        assnQlaUsage[assignmentHash] = res;
        this.emitStatus();
    },
    onGetAssnQlaUsageFailed(actionId, assignmentHash, err) {
        console.warn('onGetAssnQlaUsageFailed:', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnQlaLoUsageCompleted(actionId, assignmentHash, res) {
        // console.log('onGetAssnQlaLoUsageCompleted:', actionId, assignmentHash, res);
        action = { id: actionId };
        assnQlaLoUsage[assignmentHash] = res;
        this.emitStatus();
    },
    onGetAssnQlaLoUsageFailed(actionId, assignmentHash, err) {
        console.warn('onGetAssnQlaLoUsageFailed:', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnQlaQuestionSummaryCompleted(actionId, assignmentHash, res) {
        // console.log('onGetAssnQlaQuestionSummaryCompleted:', actionId, assignmentHash, res);
        action = { id: actionId };
        assnQlaQuestionSummary[assignmentHash] = res;
        this.emitStatus();
    },
    onGetAssnQlaQuestionSummaryFailed(actionId, assignmentHash, err) {
        console.warn('onGetAssnQlaQuestionSummaryFailed:', actionId, assignmentHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetAssnQlaQuestionDetailsCompleted(actionId, assignmentHash, questionId, res) {
        // console.log('onGetAssnQlaQuestionDetailsCompleted:', actionId, assignmentHash, questionId, res);
        action = { id: actionId };
        if (!assnQlaQuestionDetails[assignmentHash]) {
            assnQlaQuestionDetails[assignmentHash] = {};
        }

        assnQlaQuestionDetails[assignmentHash][questionId] = res;
        this.emitStatus();
    },
    onGetAssnQlaQuestionDetailsFailed(actionId, assignmentHash, questionId, err) {
        console.warn('onGetAssnQlaQuestionDetailsFailed:', actionId, assignmentHash, questionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    
    onGetShortCourseInstanceStatsCompleted: function(actionID, instanceHash, res) {
        // console.log("onGetShortCourseInstanceStatsCompleted: ", actionID, instanceHash, res);
        action = {id: actionID};
        if(shortCourseInstanceStats[instanceHash]) {
            delete shortCourseInstanceStats[instanceHash];
        }
        shortCourseInstanceStats[instanceHash] = res;
        this.emitStatus();
    },

    onGetShortCourseInstanceStatsFailed(actionId, instanceHash, err) {
        console.warn('onGetShortCourseInstanceStatsFailed:', actionId, instanceHash, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

});

module.exports = AnalyticsStore;
